// Двете ленти под схемата в режим „Схема" — цели статични низове, за да ги
// види Tailwind. Само съществуващи токени (със стойности и в тъмната тема);
// цветът на `ring-offset` е цветът на лентата.

export type SchemaBillStripTone = "temporary" | "nonFiscal";

export const SCHEMA_BILL_STRIP_TONES: Record<
  SchemaBillStripTone,
  {
    titleKey: string;
    hintKey: string;
    band: string;
    labelDivider: string;
    title: string;
    hint: string;
    tile: string;
    closingTile: string;
    selectedRing: string;
  }
> = {
  // „Временни маси" — синьото на палитрата (`info`): различно от
  // свободна/резервирана/заета.
  temporary: {
    titleKey: "ordering.schema.temporaryTables",
    hintKey: "ordering.schema.temporaryTablesHint",
    band: "border-info/40 bg-info-tint",
    labelDivider: "border-info/20",
    title: "text-info-deep",
    hint: "text-muted",
    tile: "cursor-pointer bg-info text-surface shadow-[0_2px_0_var(--color-info-deep)] hover:-translate-y-px",
    closingTile: "cursor-not-allowed border border-info/30 bg-surface text-info-deep",
    selectedRing: "ring-2 ring-info-deep ring-offset-2 ring-offset-info-tint",
  },
  // „Нефискализирани маси" — сиво: закрити, чакат касова бележка.
  nonFiscal: {
    titleKey: "ordering.schema.nonFiscalTables",
    hintKey: "ordering.schema.nonFiscalTablesHint",
    band: "border-shade-4 bg-fill-2",
    labelDivider: "border-shade-3",
    title: "text-body",
    hint: "text-soft",
    tile: "cursor-pointer bg-fill-3 text-ink-2 shadow-[0_2px_0_var(--color-schema-table-edge)] hover:-translate-y-px",
    closingTile: "cursor-not-allowed border border-shade-3 bg-surface text-ink-2",
    selectedRing: "ring-2 ring-soft ring-offset-2 ring-offset-fill-2",
  },
};
